import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsCardModel from './pcs-card.ts';

export interface PcsTransitionLogEntry {
  from: string;
  to: string;
  event: string;
  reason?: Record<string, unknown>;
  timestamp: string;
  user_id?: string | null;
}

export default class PcsAuthorizationModel extends Model {
  @attr declare state: string;
  @attr declare provider: string;
  @attr declare providerId: string;
  @attr declare amount: number;
  @attr declare providerData: Record<string, unknown>;
  @attr declare transitionLog: PcsTransitionLogEntry[];
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('pcs-card', { async: false, inverse: 'pcsAuthorizations' })
  declare pcsCard: PcsCardModel;

  [Type] = 'pcs-authorization' as const;
}
